module.exports = __webpack_public_path__ + "static/dr-karen-dd0ae0f7c858635912cb0504849bf432.jpeg";